import { render } from "./DataParseCompForPdfTrans.vue?vue&type=template&id=70a37650&scoped=true"
import script from "./DataParseCompForPdfTrans.vue?vue&type=script&lang=js"
export * from "./DataParseCompForPdfTrans.vue?vue&type=script&lang=js"

import "./DataParseCompForPdfTrans.vue?vue&type=style&index=0&id=70a37650&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a37650"]])

export default __exports__